<template>
  <div
    v-show="show"
    class="alert"
  >
    <v-card class="alert-content">
      <div class="alert-img">
        <img
          :src="AlertImages[type]"
          alt="alert"
          @click="clear"
        >
      </div>
      <div class="alert-message mt-5">
        <pre>{{ message }}</pre>
        <pre class="mt-3">{{ messageSup }}</pre>
      </div>
      <div class="bloc pull-bottom px-3">
        <v-btn
          v-for="(button, i) in buttonsRender"
          :key="i"
          :color="button.color"
          class="bloc ma-0 mb-3"
          large
          @click="click(i)"
        >
          {{ button.title }}
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import { AlertImages } from '@/modules/Images'

// success / error / info
export default {
  name: 'Alert',

  data () {
    return {
      AlertImages,
      show: false,
      type: '',
      message: '',
      messageSup: '',
      timeout: null,
      buttons: [],
      callback: null,
      useDefaultButton: true
    }
  },

  computed: {
    // offline () { return this.$store.state.offline },
    // isNotConnected () { return this.$store.getters.isNotConnected },
    buttonsRender () {
      return this.useDefaultButton ? [ ...this.buttons, { title: 'OK', color: this.type } ] : this.buttons
    }
  },

  mounted () {
    addEventListener('alert', this.showAlert)
  },

  methods: {
    showAlert (e) {
      clearTimeout(this.timeout)
      this.timeout = null

      if (!e.alert) {
        this.clear()
      } else {
        this.type = e.alert.type
        this.buttons = e.alert.buttons
        this.callback = e.alert.callback
        this.useDefaultButton = e.alert.useDefaultButton

        // Définition du message
        this.messageSup = ''
        // if (!this.offline && this.isNotConnected ) {
        //   this.message = 'Vous n\'êtes pas connecté à internet.'
        // } else
        if (e.alert.text === 'Failed to fetch') {
          this.message = 'Une erreur de communication est survenue, merci de contrôler votre connexion internet.'
        } else if (e.alert.text === 'timeout') {
          this.message = 'Temps de réponse dépassé, merci de contrôler votre connexion internet.'
        } else {
          this.message = e.alert.text
          this.messageSup = e.alert.textSup
        }

        // Affichage + Timeout avant fermeture de l'alerte
        this.show = true
        if (e.alert.duration >= 0) {
          this.timeout = setTimeout(
            this.clear,
            e.alert.duration > 0 ? e.alert.duration
              : (this.type === 'error' ? 8000 : 4000)
          )
        }
      }
    },
    clear () {
      if (this.timeout !== null) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.show = false
      if (this.callback !== null) {
        this.callback()
      }
    },
    click (i) {
      this.clear()
      if (this.buttonsRender[i].click) {
        this.buttonsRender[i].click()
      }
    }
  }
}
</script>
